const Gender = Object.freeze([
	{ value: 1, label: 'Male' },
	{ value: 2, label: 'Female' },
]);

export default Gender;
